import { createPermissaoApi } from "@/contexts/autorizacao/permissao/api/permissaoApi";
import { useUsuarioLogado } from "@/contexts/autorizacao/usuario";
import { useAuth } from "react-oidc-context";

export const usePermissao = () => {
  const { user } = useAuth();
  const permissaoApi = createPermissaoApi(user?.access_token);
  const { usuarioLogado } = useUsuarioLogado();

  const getPermissoes = permissaoApi.listAll;

  const hasEnabledPermissao = (nomePermissao: string) => {
    if (!usuarioLogado.perfil) return false;

    const permissaoEncontrada = usuarioLogado.perfil.permissoes.find(
      (permissao) => permissao.nome === nomePermissao
    );

    return Boolean(permissaoEncontrada);
  };

  const hasEnabledRoute = (route: string) => {
    if (route.includes("requisicoes/novo")) {
      return hasEnabledPermissao("RAL_CRIAR");
    }

    if (route.includes("requisicoes/visualizar")) {
      return hasEnabledPermissao("RAL_VISUALIZAR");
    }

    if (route.includes("certificados/novo")) {
      return hasEnabledPermissao("CERTIFICADO_CRIAR");
    }

    if (route.includes("termos-notificacao/novo")) {
      return hasEnabledPermissao("TERMO_NOTIFICACAO_CRIAR");
    }

    if (route.includes("termos-notificacao/visualizar")) {
      return hasEnabledPermissao("TERMO_NOTIFICACAO_VISUALIZAR");
    }

    if (route.includes("relatorioAM/novo")) {
      return hasEnabledPermissao("RAM_CRIAR");
    }

    if (route.includes("perfis") && usuarioLogado.perfil.id !== 1) {
      return false;
    }

    return true;
  };

  return { getPermissoes, hasEnabledPermissao, hasEnabledRoute };
};
